import React, { useContext, useState } from 'react'

interface iCheckedContextProvider {
  children: React.ReactNode
}

interface iCheckedContext {
  checked: string[],
  toggleChecked: (id: string) => void,
  setChecked: (checked: string[]) => void,
  resetChecked: () => void,
  reloadIndex: number
  addReloadIndex: () => void
}

const CheckedContext = React.createContext({} as iCheckedContext)

export const CheckedContextProvider = ({ children }: iCheckedContextProvider) => {

  const [checked, setChecked] = useState<string[]>([])
  const [reloadIndex, setReloadIndex] = useState<number>(0)

  const providerValue = React.useMemo(() => ({
    checked: checked,
    toggleChecked: (id: string) => {
      if (checked.includes(id)) {
        setChecked(checked => checked.filter(ch => ch !== id))
      } else {
        setChecked(checked => [...checked, id])
      }
    },
    setChecked: setChecked,
    resetChecked: () => {
      setChecked([])
    },
    reloadIndex: reloadIndex,
    addReloadIndex: () => {
      setReloadIndex(i => i + 1)
    }
  }), [checked, reloadIndex])

  return (
    <CheckedContext.Provider value={providerValue}>
      {children}
    </CheckedContext.Provider>
  )
}

// export const withCheckedContext = (WrapedComp: any, type: string, useStoredData: boolean = true) => (props: any) =>
//   <CheckedContextProvider useStoredData={useStoredData} type={type}>
//     <WrapedComp {...props}/>
//   </CheckedContextProvider>

export const useCheckedContext = () => useContext(CheckedContext)
